<template>
  <v-container
    data-vue-component-name="KeyboardStringTest"
    fill-height
    fluid
    class="align-start pa-16"
    @click.self="logger($event, 'Whitespace', false)"
    @contextmenu.prevent.self="logger($event, 'Whitespace', false)"
  >
    <v-row class="flex-column events-none" align="center">
      <h3 class="font-weight-bold mb-2">{{ getExerciseTitle }}</h3>
    </v-row>

    <v-row justify="center" class="events-none">
      <v-col
        v-for="(letter, index) in $options.pattern"
        :key="index"
        :class="['letter-container', index <= (activeIndex - 1) && 'passed']"
      >
        {{ letter }}
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { softGet } from '@/composables';

const EVENT_TYPES = {
  click: 'leftClickDown',
  contextmenu: 'rightClickDown',
  keydown: 'keyButtonDown',
};

export default {
  name: 'KeyboardStringTest',
  pattern: 'ZZMMMZMZMMZMZZZM',
  data() {
    return {
      activeIndex: 0,
      progress: 0,
      logs: [],
    };
  },
  mounted() {
    document.addEventListener('keydown', this.onKeyDown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeyDown);
  },
  computed: {
    ...mapGetters([
      'getExerciseTitle',
      'getNumberOfSuccessAttempts',
    ]),
  },
  methods: {
    prependPrefix(str = '', prefix = '') {
      return prefix.concat(str);
    },
    correctClickHandler() {
      this.incrementProgress();
      this.updateActiveIndex();

      if (this.progress === 100) {
        this.$store.commit('SAVE_LOG', {
          key: 'keyboard_string_test',
          payload: this.logs,
        });

        this.$emit('next');
      }
    },
    updateActiveIndex() {
      this.activeIndex += 1;
    },
    incrementProgress() {
      this.progress += (100 / this.getNumberOfSuccessAttempts);
    },
    logger(e, hit_target, correct) {
      this.logs.push({
        event_type: EVENT_TYPES[e.type],
        timestamp: Date.now(),
        x_coord: softGet(e, 'x', null),
        y_coord: softGet(e, 'y', null),
        viewport_width: window.innerWidth,
        viewport_height: window.innerHeight,
        hit_target,
        correct,
        key_value: e.code || null,
      });

      if (correct) this.correctClickHandler();
    },
    onKeyDown(e) {
      this.logger(
        e,
        null,
        e.code === this.prependPrefix(this.$options.pattern[this.activeIndex], 'Key'),
      );
    },
  },
};
</script>

<style scoped lang="scss">
.letter-container {
  border: 3px solid map-get($theme-colors, 'primary');
  border-radius: 5px;
  min-width: 50px;
  max-width: 50px;
  min-height: 50px;
  max-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 21px;
  transition: 0.3s;
  margin: 5px;

  &.passed {
    background-color: map-get($theme-colors, 'primary');
    color: #fff;
  }
}
</style>
